export class UserSimpleDTO {
  constructor(
    public id: string,
    public firstName: string,
    public lastName: string,
  ) {}
}
